import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

class Rewards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ucoin: 0,
            rank: 'Bronze',
            rankColor: '#CD7F32',
            categoryFilter: 'ALL',
            rewardList: [],
            checkinDone: false,
            loginstate: false,
            username: null,
            loading: true,
        };
    }

    async componentDidMount() {
        const token = localStorage.getItem('auth_token');
        if (token) {
            try {
                const decoded = jwt_decode(token);
                const username = decoded.message.playerid;
                this.setState({ loginstate: true, username });
                await this.loadRewards(token, username);
                await this.loadCheckinStatus(token, username);
            } catch (err) {
                console.error('Rewards componentDidMount error:', err);
            }
        }
        this.setState({ loading: false });
    }

    loadRewards = async (token, username) => {
        // TODO: API endpoint /api/v1/getrewards does not exist yet
        // When implemented, it should return: { status: 200, ucoin: number, rank: string, rewardlist: [...], checkin: bool }
        try {
            // Placeholder - replace with real API call when endpoint is ready:
            // const res = await instance.post("/api/v1/getrewards", { userid: username, System: Systems }, { headers: { Authorization: `Bearer ${token}` } });
            // if (res.data.status === 200) {
            //     this.setState({ ucoin: res.data.ucoin, rank: res.data.rank, rewardList: res.data.rewardlist });
            // }
            console.log('TODO: /api/v1/getrewards not implemented');
        } catch (err) {
            console.error('loadRewards error:', err);
        }
    };

    loadCheckinStatus = async (token, username) => {
        // TODO: API endpoint /api/v1/getcheckin does not exist yet
        // When implemented, it should return: { status: 200, checked: bool }
        try {
            // const res = await instance.post("/api/v1/getcheckin", { userid: username, System: Systems }, { headers: { Authorization: `Bearer ${token}` } });
            // if (res.data.status === 200) { this.setState({ checkinDone: res.data.checked }); }
            console.log('TODO: /api/v1/getcheckin not implemented');
        } catch (err) {
            console.error('loadCheckinStatus error:', err);
        }
    };

    doCheckin = async () => {
        // TODO: API endpoint /api/v1/docheckin does not exist yet
        const token = localStorage.getItem('auth_token');
        if (!token) {
            toast.error('กรุณาเข้าสู่ระบบก่อน');
            return;
        }
        try {
            // const decoded = jwt_decode(token);
            // const username = decoded.message.playerid;
            // const res = await instance.post("/api/v1/docheckin", { userid: username, System: Systems }, { headers: { Authorization: `Bearer ${token}` } });
            // if (res.data.status === 200) {
            //     this.setState({ checkinDone: true, ucoin: this.state.ucoin + res.data.coinEarned });
            //     toast.success('เช็กอินสำเร็จ! ได้รับ ' + res.data.coinEarned + ' uCoin');
            // }
            toast.info('TODO: ระบบเช็กอินยังไม่เปิดใช้งาน');
        } catch (err) {
            console.error('doCheckin error:', err);
        }
    };

    redeemReward = async (rewardId, coinCost) => {
        // TODO: API endpoint /api/v1/redeemreward does not exist yet
        const token = localStorage.getItem('auth_token');
        if (!token) {
            toast.error('กรุณาเข้าสู่ระบบก่อน');
            return;
        }
        if (this.state.ucoin < coinCost) {
            toast.warning('uCoin ไม่เพียงพอ');
            return;
        }
        Swal.fire({
            title: 'ยืนยันการแลก?',
            text: `ใช้ ${coinCost} uCoin เพื่อแลกรางวัลนี้`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
        }).then(async (result) => {
            if (result.isConfirmed) {
                // TODO: Call /api/v1/redeemreward when endpoint is ready
                toast.info('TODO: ระบบแลกรางวัลยังไม่เปิดใช้งาน');
            }
        });
    };

    render() {
        const { ucoin, rank, rankColor, categoryFilter, rewardList, checkinDone, loading } = this.state;

        const categories = ['ALL', 'Tickets', 'Products'];

        // Sample reward items for UI display (replace with rewardList from API when ready)
        const sampleRewards = [
            { id: 1, name: 'AirPods 4', coins: 151, stock: 200, maxRedeem: 5, available: true, category: 'Products' },
            { id: 2, name: 'Apple MagSafe Charger', coins: 45, stock: 100, maxRedeem: 5, available: false, category: 'Products' },
            { id: 3, name: 'Play sport-book 20 THB', coins: 1, stock: 999, maxRedeem: 1, available: true, category: 'Tickets' },
            { id: 4, name: 'Play sport-book 50 THB', coins: 2, stock: 999, maxRedeem: 1, available: true, category: 'Tickets' },
            { id: 5, name: 'Play sport-book 100 THB', coins: 3, stock: 999, maxRedeem: 1, available: true, category: 'Tickets' },
            { id: 6, name: 'iPhone 17 256GB', coins: 1087, stock: 100, maxRedeem: 100, available: true, category: 'Products' },
        ];

        const displayRewards = rewardList.length > 0 ? rewardList : sampleRewards;
        const filtered = categoryFilter === 'ALL' ? displayRewards : displayRewards.filter(r => r.category === categoryFilter);

        return (
            <div>
                {/* Header */}
                <h1 className="text-xl text-highlight font-medium text-center mt-6 mb-4">รางวัล</h1>

                {/* uCoin + Rank Card */}
                <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/20 p-4 mb-4">
                    <div className="flex items-center justify-between mb-3">
                        <div>
                            <div className="text-xs text-gray">uCoin ของคุณ</div>
                            <div className="text-2xl font-bold text-highlight">{ucoin.toFixed(1)}</div>
                        </div>
                        <div className="text-right">
                            <div className="text-xs text-gray mb-1">Rank ปัจจุบัน</div>
                            <div className="flex items-center gap-2 justify-end">
                                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: rankColor }}></div>
                                <span className="font-semibold">{rank}</span>
                            </div>
                        </div>
                    </div>
                    {/* Check-in button */}
                    <button
                        onClick={this.doCheckin}
                        disabled={checkinDone}
                        className={`w-full py-3 rounded-xl font-semibold text-sm transition-all ${
                            checkinDone
                                ? 'bg-input text-gray cursor-not-allowed'
                                : 'bg-gradient-to-br from-button-f to-button-t hover:opacity-90'
                        }`}
                    >
                        {checkinDone ? '✓ เช็กอินแล้ววันนี้' : '🎯 เช็กอินเลย!'}
                    </button>
                </div>

                {/* uCoin Info Card */}
                <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/20 p-4 mb-4">
                    <div className="text-sm font-semibold mb-3 text-highlight">แลก uCoin</div>
                    <div className="grid grid-cols-2 gap-2 text-xs text-gray">
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-highlight rounded-full"></div>
                            เล่น 100,000 Turnover = 1 uCoin
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-highlight rounded-full"></div>
                            เช็กอินโบนัส uCoin ทุกวัน
                        </div>
                    </div>
                </div>

                {/* Category Filter */}
                <div className="flex gap-2 mb-4 overflow-x-auto pb-1">
                    {categories.map(cat => (
                        <button
                            key={cat}
                            onClick={() => this.setState({ categoryFilter: cat })}
                            className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all ${
                                categoryFilter === cat
                                    ? 'bg-gradient-to-br from-button-f to-button-t text-white'
                                    : 'bg-input text-gray'
                            }`}
                        >
                            {cat}
                        </button>
                    ))}
                </div>

                {/* Reward Grid */}
                <div className="grid grid-cols-2 gap-3">
                    {filtered.map((item) => {
                        const canRedeem = ucoin >= item.coins && item.stock > 0;
                        return (
                            <div key={item.id} className="bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/20 p-3 flex flex-col">
                                <div className="bg-input rounded-lg h-20 flex items-center justify-center mb-2">
                                    <svg width={40} height={40} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 12V22H4V12M22 7H2V12H22V7Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M12 22V7M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <div className="text-xs font-medium mb-1 line-clamp-2 flex-1">{item.name}</div>
                                <div className="text-highlight text-sm font-bold mb-1">{item.coins.toLocaleString()} coins</div>
                                <div className="text-xs text-gray mb-2">
                                    คลัง: {item.stock === 999 ? '∞' : item.stock} / แลกได้: {item.maxRedeem}
                                </div>
                                <button
                                    onClick={() => this.redeemReward(item.id, item.coins)}
                                    disabled={!canRedeem}
                                    className={`w-full py-1.5 rounded-lg text-xs font-medium transition-all ${
                                        item.stock === 0
                                            ? 'bg-input text-gray cursor-not-allowed'
                                            : canRedeem
                                                ? 'bg-gradient-to-br from-button-f to-button-t hover:opacity-90'
                                                : 'bg-input text-gray cursor-not-allowed'
                                    }`}
                                >
                                    {item.stock === 0 ? 'หมด' : canRedeem ? 'แลกเลย' : 'uCoin ไม่เพียงพอ'}
                                </button>
                            </div>
                        );
                    })}
                </div>

                {loading && (
                    <div className="text-center text-gray text-sm mt-4">กำลังโหลด...</div>
                )}

                {/* TODO Notice */}
                <div className="mt-4 p-3 bg-input rounded-xl text-xs text-gray">
                    <div className="font-semibold text-highlight mb-1">⚠️ หมายเหตุ (สำหรับนักพัฒนา)</div>
                    <div>ระบบ uCoin/Rewards ยังไม่มี API backend รองรับ กรุณาเพิ่ม endpoints ต่อไปนี้:</div>
                    <ul className="mt-1 space-y-0.5 list-disc list-inside">
                        <li>/api/v1/getrewards - ดึงข้อมูล uCoin และรายการรางวัล</li>
                        <li>/api/v1/getcheckin - ตรวจสอบสถานะเช็กอิน</li>
                        <li>/api/v1/docheckin - ทำการเช็กอิน</li>
                        <li>/api/v1/redeemreward - แลกรางวัล</li>
                        <li>/api/v1/getrank - ดึงข้อมูล rank ของสมาชิก</li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Rewards;
